import MetricModel from "./MetricModel";
import MetricOperations, { PageTypes } from "./MetricOperations";
import { parseJson } from "src/shared/utils";

type CategoriesData = {
  group: string;
  metrics: MetricModel[];
  id: string;
};

export default class CategoriesModel extends MetricOperations {
  public data: CategoriesData[];
  public constructor(obj, permittedMetrics?: number[]) {
    super();
    this.data = [];
    this.data = (obj || [])
      .map((group) => {
        const key = Object.keys(group)[0];
        let metrics =
          permittedMetrics === undefined
            ? (group[key] || []).map(MetricModel.createMetric)
            : (group[key] || []).filter(({ id }) => permittedMetrics.includes(id)).map(MetricModel.createMetric);

        return {
          group: key,
          metrics,
          id: key,
        };
      })
      .filter(({ metrics }) => metrics.length > 0);
  }
  public static createMetric(obj: any, permittedMetrics?: number[]) {
    return new CategoriesModel(obj, permittedMetrics);
  }
  public static mergeMetrices(obj: CategoriesModel): MetricModel[] {
    return obj.data.reduce((acc, item: CategoriesData) => acc.concat(item.metrics), [] as MetricModel[]);
  }
  public static getCategoryBulkChartRequest(
    chronicFilter,
    categoryMetrices,
    adhocFilters: IObject<Array<string>>,
    filterConfig
  ) {
    const filters = Object.entries(adhocFilters)
      .map(([key, value]) => ({
        field: key,
        value,
      }))
      .filter((filter) => !!filter.value.length);

    const reqObject = categoryMetrices.data.reduce(
      (acc, item) =>
        acc.concat(
          parseJson(
            MetricOperations.getBulkChartRequest(
              chronicFilter,
              item.metrics,
              PageTypes.L2,
              "metric",
              filters,
              filterConfig
            )
          )
        ),
      []
    );
    return JSON.stringify(reqObject);
  }
  public static combineCategoryChart(fetchedCharts, categories) {
    let x = [];
    const newCategories = { ...categories };
    categories.data.forEach((element, index) => {
      x = MetricOperations.combineMetricsAndCharts(
        fetchedCharts,
        {
          data: element.metrics || [],
        },
        PageTypes.L2
      );
      newCategories.data[index].metrics = x;
    });
    return newCategories;
  }
  public static calculateEachChart(charts, timeTab) {
    const newCharts = { ...charts }; //TODO safeSet utility
    charts.data.forEach((item, index) => {
      item.metrics.forEach((metric, i) => {
        newCharts.data[index].metrics[i] = MetricOperations.calculateChartsData(metric, timeTab);
      });
    });
    return newCharts;
  }
}
